import './logowall.scss';
import Swiper from 'swiper';
import { Navigation, A11y } from 'swiper/modules';

class Logowall {
    constructor (element, options) {
        // Defaults & Settings
        const defaults = {
            initAttr: 'data-logowall',
            sliderValue: 'slider',
            prevValue: 'prev',
            nextValue: 'next'
        };

        this.settings = Object.assign({}, defaults, options);

        // Elements
        this.$root = element;
        this.$slider = this.$root.querySelector(`[${this.settings.initAttr}="${this.settings.sliderValue}"]`);
        this.$prevBtn = this.$root.querySelector(`[${this.settings.initAttr}="${this.settings.prevValue}"]`);
        this.$nextBtn = this.$root.querySelector(`[${this.settings.initAttr}="${this.settings.nextValue}"]`);

        // Properties
        this.slider = null;
        this.sliderActive = false;
    }

    initialize () {
        this.checkSize();
        this.setEvents();
    }

    initSlider () {
        this.slider = new Swiper(this.$slider, {
            modules: [Navigation, A11y],
            speed: 500,
            slidesPerView: 1,
            a11y: true,
            navigation: {
                prevEl: this.$prevBtn,
                nextEl: this.$nextBtn
            }
        });

        this.sliderActive = true;
    }

    checkSize () {
        if (window.innerWidth < 768) {
            if (this.sliderActive === false) {
                this.initSlider();
            }
        } else {
            if (this.sliderActive === true) {
                this.destroySlider();
            }
        }
    }

    destroySlider () {
        if (this.slider !== null) {
            this.slider.destroy(true, true);
            this.slider = null;
            this.sliderActive = false;
        }
    }

    setEvents () {
        window.mediaMatch[768].addEventListener('change', () => {
            this.checkSize();
        });
    }
}

export { Logowall };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $$roots = $context.querySelectorAll('[data-logowall="root"]');
        $$roots.forEach($root => {
            const $rootAPI = new Logowall($root);
            $rootAPI.initialize();
        });
    }
});
